export default async src => new Promise((resolve, reject) => {
	const script = document.createElement('script');
	script.setAttribute('src', src);
	if (script.readyState) {
		script.onreadystatechange = () => {
			if (script.readyState === 'loaded' || script.readyState === 'complete') {
				script.onreadystatechange = null;
				resolve({ src });
			}
		};
	} else {
		script.onload = () => {
			resolve({ src });
		};
	}
	script.onerror = error => {
		reject(error);
	};
	document.head.appendChild(script);
});
